<template>
  <div class="mt-4">
    <v-skeleton-loader
      v-for="n in count"
      :key="n"
      type="card"
      class="mb-4"
    />
  </div>
</template>

<script>
export default {
  name: "CardSkeletonList",
  props: {
    count: {
      type: Number,
      default: 1,
    },
  },
};
</script>
